<template>
  <div class="panel">
    <div class="title bg-[url('@a/views/Home/images/i_par.png')]">
      <span class="txt">{{ $t('home.Footer.Partners') }}</span>
    </div>
    <div class="container">
      <div key={item.id} v-for="item in config.brandList" class="item cItem">
        <div class="cItem-content">
          <Image :src="item.imgUrl" />
        </div>
      </div>
    </div>
  </div>

  <div class="panel">
    <div class="title bg-[url('@a/views/Home/images/i_can.png')]">
      <span class="txt">{{ $t('home.Footer.OfficialChannel') }}</span>
    </div>

    <div class="flex-around-x py-4">
      <div v-for="(item, index) in mediaList" class="size-6" :key="index" @click="handleMedia(item)">
        <Image :src="item.customIcon || `local://${item.mediaType}.png`" class="size-full" />
      </div>
    </div>
  </div>

  <div class="desc">
    <div class="desc-name">{{ config.siteName }}</div>
    <div class="desc-text">
      <p class="w-full break-words">{{ bottomText }}</p>
    </div>
    <div class="desc-tips">
      {{ $t('home.Footer.DireitosReservados', {siteName: config.siteName}) }}
    </div>
    <div class="desc-version">{{ $t('home.Footer.Ver') }}</div>
  </div>
</template>

<script setup lang="ts">
  import config from '@/config'
  // import { getFooterInfo } from '@/api'
  import { useHomeBannersAndTexts } from '@/store'

  const handleMedia = val => {
    if (val.hyperlink) {
      window.open(val.hyperlink);
    }
  };

  const mediaList = computed(() => useHomeBannersAndTexts().socialMedia)
  const bottomText = computed(() => useHomeBannersAndTexts().bottomText?.text)
</script>

<style lang="scss" scoped>
.panel {
  font-size: 13px;
  padding-bottom: 12px;

  .title {
    background-position: 16px center;
    background-repeat:no-repeat;
    background-size: 24px;

    padding-left: 17px;
    position: relative;
    //display: flex;
    height: 48px;
    // line-height: 48px;
    font-size: 16px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.85);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .txt {
      position: absolute;
      left: 52px;
    }
  }

  .container {
    display: flex;
    flex-wrap: wrap;
    padding: 0 3px 0 16px;
    padding-top: 8px;
    .item {
      padding-right: 8px;
      // padding-bottom: 8px;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
    }
    .cItem {
      width: 33.3%;
      height: 70px;
      .cItem-content {
        width: 100%;
        height: 75px;
        border-radius: 8.8px;
        // background: #ffffff0a;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0);
        img {
          position: absolute;
          top: 50%;
          left: 0;
          margin-top: -18px;
          width: 115px;
          height: 35px;
        }
      }
    }
  }
}

.desc {
  position: relative;
  color: #fff;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  margin-top: 12px;
  padding-bottom: 100px;

  .desc-name {
    height: 20px;
  }
  .desc-text {
    margin: 12px 20px 0 20px;
    white-space: pre-wrap;
    text-align: left;
  }
  .desc-tips {
    margin-top: 16px;
    font-weight: 600;
  }
}
</style>
